import clsx from 'clsx';
import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

interface Props extends PropsWithChildren {
  containerClassName?: string;
  clamp: 1 | 2 | 3 | 4 | 5 | 6;
  buttonClassName?: string;
}

const lineClampClasses = {
  1: 'line-clamp-1',
  2: 'line-clamp-2',
  3: 'line-clamp-3',
  4: 'line-clamp-4',
  5: 'line-clamp-5',
  6: 'line-clamp-6'
};

const ClampedText: React.FC<Props> = ({
  clamp,
  children,
  containerClassName,
  buttonClassName
}) => {
  const { t } = useTranslation();
  const textRef = useRef<HTMLSpanElement | null>(null);

  const [clamped, setClamped] = useState(false);
  const [expanded, setExpanded] = useState(false);

  function checkTextContent() {
    if (
      textRef.current &&
      textRef.current.scrollHeight > textRef.current.clientHeight
    ) {
      setClamped(true);
    } else {
      setClamped(false);
    }
  }

  useEffect(() => {
    checkTextContent();

    window.addEventListener('resize', checkTextContent);

    return () => {
      window.removeEventListener('resize', checkTextContent);
    };
  }, []);

  return (
    <p className={clsx('relative', containerClassName)}>
      <span
        ref={textRef}
        className={clsx({ [lineClampClasses[clamp]]: !expanded })}
      >
        {children}
      </span>

      {clamped && (
        <button
          onClick={() => setExpanded(expanded => !expanded)}
          className={twMerge(
            clsx(
              'absolute bottom-0 right-0 pl-12 bg-gradient-to-l from-white from-50% to-transparent underline ' +
                { hidden: !clamped || expanded }
            ),
            buttonClassName
          )}
        >
          {!expanded ? t('MORE') : t('LESS')}
        </button>
      )}
    </p>
  );
};

export default ClampedText;
